import React from "react";
import { Link, RichText } from "prismic-reactjs";
import Grid from "@material-ui/core/Grid";
import linkResolver from "../helpers/linkResolver";
import isValidLink from "../helpers/isValidLink";
import { get } from "lodash";

export default function ColumnSlice(slice) {
  const backgroundStyle = {
    backgroundColor: get(slice.primary, "background_color"),
    color: get(slice.primary, "text_color"),
  };

  const renderColumns = (items) => {
    return items.map((el, i) => {
      const ctaText = el.cta_text;
      const ctaLink = el.cta_link;
      const bgStyle = {
        backgroundImage: `url(${el.background_image.url})`,
        padding: el.background_image.url ? "50px 20px" : "20px",
      };
      return (
        <Grid item key={i} className="column" xs={12} sm style={bgStyle}>
          {el.foreground_image.url && (
            <div className="foreground-image">
              <img src={el.foreground_image.url} alt="Hero Element" />
            </div>
          )}

          <div
            className="content"
            style={{ textAlign: "center", color: "white" }}
          >
            <RichText render={el.content} />
          </div>
          {isValidLink(ctaLink, ctaText) && (
            <div className="buttons">
              <a href={Link.url(ctaLink, linkResolver)} className="button">
                {ctaText[0].text}
              </a>
            </div>
          )}
        </Grid>
      );
    });
  };
  return (
    <section
      className="column-section standard-padding"
      style={backgroundStyle}
    >
      <div className="wrapper">
        <div className="content">
          <RichText render={slice.primary.content} />
        </div>
        <Grid container className="columns">
          {renderColumns(slice.items)}
        </Grid>
      </div>
    </section>
  );
}
